<template>
  <div class="customers">
    <v-container fluid class="pt-0 ">
      <v-card class="no-shadow pa-2">
      <v-toolbar class="primary card-r pl-3 text-white mb-3">
          <div class="text-xs-left f-20">Customers</div>
        <!--<v-layout wrap row align-center>-->
          <!--<v-flex xs12 lg7>-->
            <!--<div class="text-xs-left f-20">Customers</div>-->
          <!--</v-flex>-->
          <!--<v-flex xs12 lg5 class="ma-auto pa-3 tabel-slc">-->
            <!--<v-text-field solo append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>-->
          <!--</v-flex>-->
        <!--</v-layout>-->
      </v-toolbar>
      <Table class="pt-0" v-if="loading===false" :headers="headers" :items="customers"
             :pagination="pagination" @view="viewCustomer"></Table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
    /* eslint-disable */
    import Table from "@/components/Table.vue";
    import SearchPanel from "@/components/SearchPanel.vue";
    import ConfirmDialog from "@/components/ConfirmDialog.vue";
    import { mapState } from "vuex";

    export default {

        data: () => ({
            dialog: false,
            // status:null,
            Membershipdata:null,
            selected: [],
            headers: [
                {
                    text: "School Name",
                    value: "schoolName"
                },

                {
                    text: "Contact Person",
                    value: "admin"
                },
                {
                    text: "Contact Number",
                    value: "club_phone"
                },
                {
                    text: "Email",
                    value: "email"
                },
                {
                    text: "Status",
                    value: "status",
                    sortable: false
                },

                // {
                //     text: "Withdraw Amount",
                //     value: "last_payment_request_amount"
                // },

                {
                    text: "Total Balance",
                    value: "club_earnings"
                },
                {
                    text: "Packages",
                    value: "package",
                    sortable: false
                }
            ],

        }),

        computed: {
            ...mapState({
                customers: "customers",
                pagination: "pagination",
                loading: "loading",
                mode: "mode",
                // snackbar: "snackbar",
                // notice: "notice"
            }),
        },

        watch: {},

        created() {
            Store.dispatch('getAllCustomers')
            //  this.getpackage ()
            //  this.GetDetails()
        },


        methods: {
            getpackage (){
                this.$store.dispatch('getPackage').then(res=>{

                    this.Membershipdata = res.data

                },error=>{

                })
            },
            getPackageName(data){
                var packagename=[]
                for (let i = 0; i < data.length; i++) {
                    for(let key in this.Membershipdata){
                        if (data[i]== this.Membershipdata[key].id){
                            packagename.push(this.Membershipdata[key].name)
                        }
                    }
                }
                return packagename
            },

            viewCustomer(id) {
                this.$router.push("/editcustomer/" + id);
            },
            StatusEnabled(id){
            },
            deleteClub(id) {
            },
            loginClub(Id) {}
        },



        components: {
            Table,
            SearchPanel,
            ConfirmDialog
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/pages/customers/Customers.vue